<template>
    <div>

        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="content-container">
                        <SportipsButton toPage="Home" chevronLeft mobile-full-width>Retour à
                            l'accueil</SportipsButton>


                        <div class="text-h6 font-weight-bold my-3"><v-icon icon="mdi-cash" color="primary"
                                size="xs-small"></v-icon>Achat
                            d'un dossard en bourse</div>




                        <!-- Boucle sur les inscriptions de la réservation -->
                        <div class="my-3" v-for="(inscription, index_inscription) in bookingStore.inscriptions"
                            :key="index_inscription + '_' + bookingStore.inscriptions.length">

                            <InscriptionItem :item="inscription"
                                :open_first_tab="index_inscription == bookingStore.inscriptions.length - 1"
                                :index="index_inscription" @deleteItem="deleteInscription(index_inscription)">
                            </InscriptionItem>
                        </div>



                        <!-- Affiche les checkboxes de prises de connaissances -->
                        <v-row v-if="bookingStore.show_reglement_checkboxes">
                            <v-col>
                                <v-checkbox v-if="!has_remove_checkboxes_fin_inscription"
                                    class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                                    v-model="accept_reglement">
                                    <template v-slot:label v-if="!mainStore.billetterie_mode">
                                        <p>J'ai pris connaissance du <a v-if="mainStore.module.url_reglement"
                                                target="_blank"
                                                :href="mainStore.module.url_reglement">règlement</a><span
                                                v-else>règlement</span>, en accepte
                                            les termes sans réserve.</p>
                                    </template>
                                    <template v-slot:label v-else>
                                        <p>J'ai pris connaissance des <a v-if="mainStore.module.url_reglement"
                                                target="_blank" :href="mainStore.module.url_reglement">CGV</a><span
                                                v-else>CGV</span>, en accepte les termes
                                            sans réserve.</p>
                                    </template>
                                </v-checkbox>
                                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                                    v-model="accept_donnees">
                                    <template v-slot:label>
                                        <p>J'ai pris connaissance des <a href="https://sportips.fr/vie-privee.php"
                                                target="_blank">informations relatives au traitement de mes données</a>,
                                            dont j'autorise le
                                            recueil par Sportips.</p>
                                    </template>
                                </v-checkbox>
                                <v-checkbox v-if="!has_remove_checkboxes_fin_inscription"
                                    class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                                    v-model="accept_newsletter">
                                    <template v-slot:label>
                                        <p>J'accepte de recevoir les news Courses de la part de Sportips.</p>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>

                        <PopupErrorFFR class="my-3"
                            v-if="mainStore.module.is_longe_cote_ffrp && validation_ffr && validation_ffr.details"
                            :validation="validation_ffr">
                        </PopupErrorFFR>

                        <GestionEquipes v-if="mainStore.module.need_gestion_equipe && mainStore.bookingSystem">
                        </GestionEquipes>

                        <!-- Bouton de finalisation de la commande -->
                        <div class="d-flex justify-center mb-1 mx-1" v-if="bookingStore.show_reglement_checkboxes">

                            <v-btn v-if="bookingStore.has_some_inscriptions_opened" color="primary-dark"
                                class="sm-fullwidth mt-2 inscription_btn cursor_lock" variant="tonal" size="small">
                                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                                <v-tooltip activator="parent" location="top">Vous devez compléter l'inscription ouverte
                                    afin de
                                    finaliser votre
                                    inscription</v-tooltip>
                            </v-btn>
                            <v-btn v-else-if="!accept_donnees || !accept_reglement" color="primary-dark"
                                class="sm-fullwidth mt-2 inscription_btn cursor_lock" variant="tonal" size="small">
                                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                                <v-tooltip activator="parent" location="top">Vous devez accepter le règlement de
                                    l'épreuve et autoriser
                                    Sportips à
                                    traiter vos données</v-tooltip>
                            </v-btn>
                            <v-btn v-else-if="!mainStore.bookingSystem.equipes.equipes_have_valid_names"
                                color="primary-dark" class="sm-fullwidth mt-2 inscription_btn cursor_lock"
                                variant="tonal" size="small">
                                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                                <v-tooltip activator="parent" location="top">Vous devez donner un nom valide à vos
                                    équipes sur les
                                    courses en
                                    duo/équipe</v-tooltip>
                            </v-btn>
                            <v-btn v-else-if="!mainStore.bookingSystem.equipes.equipes_are_full" color="primary-dark"
                                class="sm-fullwidth mt-2 inscription_btn cursor_lock" variant="tonal" size="small">
                                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                                <v-tooltip activator="parent" location="top">Le nombre de coureur requis n'est pas
                                    atteint pour une de
                                    vos
                                    équipes</v-tooltip>
                            </v-btn>

                            <v-btn v-else-if="!mainStore.bookingSystem.equipes.equipes_have_fields" color="primary-dark"
                                class="sm-fullwidth mt-2 inscription_btn cursor_lock" variant="tonal" size="small">
                                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                                <v-tooltip activator="parent" location="top">Vous devez remplir tous les champs
                                    additionnels pour vos
                                    équipes</v-tooltip>
                            </v-btn>
                            <v-btn v-else-if="!mainStore.bookingSystem.equipes.equipes_have_valid_sexes"
                                color="primary-dark" class="sm-fullwidth mt-2 inscription_btn cursor_lock"
                                variant="tonal" size="small">
                                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                                <v-tooltip activator="parent" location="top">Certaines de vos équipes doivent être
                                    mixtes pour cette course</v-tooltip>
                            </v-btn>

                            <v-btn v-else-if="mainStore.module.is_longe_cote_ffrp" @click="check_equipes_ffr()"
                                color="primary-dark" class=" mt-2 inscription_btn" variant="tonal" size="small">
                                <v-icon icon="mdi-arrow-right-bold"></v-icon>Finaliser mon inscription</v-btn>




                            <router-link class="sm-fullwidth" v-else :to="{ name: 'Cart' }">
                                <v-btn color="primary-dark" block class="sm-fullwidth mt-2 inscription_btn"
                                    variant="tonal" size="small">
                                    <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription </v-btn>
                            </router-link>

                        </div>

                    </div>
                </v-col>
                <v-col lg="3" cols="12">
                    <ShoppingCart v-if="bookingStore" ref="shopping_cart">
                    </ShoppingCart>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import InscriptionItem from "@/components/Inscription/InscriptionItem.vue";
import ShoppingCart from "@/components/App/Shopping_Cart/Shopping_Cart.vue";
import EquipeFFRValidator from "@/classes/Equipe/EquipeFFRValidator.class";
import PopupErrorFFR from "@/components/Inscription/PopupErrorFFR.vue";
import GestionEquipes from "@/components/Inscription/GestionEquipes.vue";

import PublicService from "@/services/public.service";

export default {
    components: { InscriptionItem, ShoppingCart, PopupErrorFFR, GestionEquipes },
    data() {
        return {
            equipes: [],
            accept_reglement: false,
            accept_donnees: false,
            accept_newsletter: true,
            validation_ffr: {},
            loaded: false,
            dossard_bourse: null,
        };
    },
    watch: {
        "bookingStore.inscriptions": {
            deep: true,
            handler() {
                this.$forceUpdate();
            },
        },
    },
    computed: {
        ...mapStores(useMainStore, useBookingStore),
        has_remove_checkboxes_fin_inscription() {
            return this.mainStore.module.has_remove_checkboxes_fin_inscription;
        },
    },
    methods: {
        check_equipes_ffr() {
            let validator = new EquipeFFRValidator(this.bookingStore.$state, this.mainStore.bookingSystem.equipes.list, this.mainStore.module.courses.list, this.mainStore.module);
            this.validation_ffr = validator.validate();

            if (this.validation_ffr.status) {
                this.$router.push({ name: "Cart" });
            }
        },


        deleteInscription(index) {
            this.bookingStore.removeInscription(index);
            this.bookingStore.compute_cart();
        },

        check_access() {
            const is_loaded = this.mainStore.module.isLoaded;
            const is_dossard_bourse_loaded = this.dossard_bourse != null;
            const is_dossard_bourse_valid = this.dossard_bourse.status !== 'PAID';
            const is_dossard_bourse_active = this.mainStore.module.bourse_dossards_is_active;
            const is_same_module = this.mainStore.module.id == this.dossard_bourse.id_module;
            if (!is_same_module) {
                this.mainStore.notification.send("Ce lien n'est pas valide", "error");
                this.$router.push({ name: "Home" });
            }
            if (!is_loaded) {
                this.mainStore.notification.send("Une erreur est survenue", "error");
                this.$router.push({ name: "Home" });
            }
            if (!is_dossard_bourse_loaded) {
                this.mainStore.notification.send("Une erreur est survenue", "error");
                this.$router.push({ name: "Home" });
            }
            if (!is_dossard_bourse_valid) {
                this.mainStore.notification.send("Ce dossard n'est plus disponible", "error");
                this.$router.push({ name: "Home" });
            }
            if (!is_dossard_bourse_active) {
                this.mainStore.notification.send("La bourse aux dossards n'est plus active", "error");
                this.$router.push({ name: "Home" });
            }
        },
        async load_dossard_bourse() {
            const id_dossard_bourse = this.$route.params.id_dossard_bourse;
            const request = await PublicService.getDossardBourse(id_dossard_bourse);
            if (request) {
                this.dossard_bourse = request;

            }

        }
    },
    async created() {



        // Toujours activer le mode dossard_bourse
        this.mainStore.dossard_bourse_mode = true;


        await this.load_dossard_bourse();
        this.check_access();
        this.mainStore.bookingSystem.init_from_dossard_bourse(this.dossard_bourse);
        await this.mainStore.champs_formulaire.fetch();


        // Toujours initialiser les checkboxes et loaded
        if (this.has_remove_checkboxes_fin_inscription) {
            this.accept_reglement = true;
            this.accept_newsletter = false;
        }

        this.loaded = true;
    },
};
</script>

<style lang="scss">
.checkbox_connaissance .v-selection-control--inline {
    width: 100%;
    height: auto;
}

.checkbox_connaissance p {
    margin-bottom: 0;
}

.checkbox_connaissance .v-selection-control__wrapper {
    align-self: start !important;
}
</style>